import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";

import {setContractSigningStep, setContractsList} from "../../../actions/contractsActions";
import {
  getAllContractsValues,
  setContractBlobs
} from "./contractsFunctions";
import LoadingSpinner from "../../ui/loadingSpinner";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import ContractsPopupSuccess from "./contractsPopupSuccess";
import ContractsPopupDocument from "./contractsPopupDocument";
import ContractsContext, {initialContext} from "./contractsContext";
import {getCurrentReceiptPages} from "../../../actions/printFunctions";
import {showOrderCompletePopup} from "../../../actions/shoppingCartFunctions";
import {toggleShowAssignQuotePopup} from "../../../actions/assignPopupFunctions";
import Config from "../../../config";

const ContractsPopup = (props) => {

  const {contractsList, setContractsList, isSignaturePadVisible, step, contractsReceived, fabricatorSettings,
    showOrderCompletePopup, toggleShowAssignQuotePopup, showAssignQuotePopup, setContractSigningStep,
    visualizersLoadedLength, signedDocumentUrl} = props;

  const history = useHistory();
  const [context, setContext] = useState(initialContext);

  const showReceiptInContract = true; // to change on fab setting if needed

  const checkContractBlobs = async () => {
    if (!visualizersLoadedLength) {
      return
    }
    loaderEnable("loader.contractSignMessage", "loader.contractSignTitle");
    let receiptUrl = context.receiptUrl,
      receiptPages = context.receiptPages,
      receiptLayout = context.receiptLayout;
    if (showReceiptInContract) {
      const contractData = await getCurrentReceiptPages(true);
      receiptUrl = contractData.receiptUrl;
      receiptPages = contractData.receiptPages;
      receiptLayout = contractData.receiptLayout;
      console.log("contractData", contractData);
    }
    const {updatedContractsList, totalPages} = await setContractBlobs(contractsList, receiptPages);
    setContext({...context, totalPages, receiptUrl, receiptPages, receiptLayout});
    setContractsList([...updatedContractsList]);
    loaderDisable();
  }

  useEffect(() => {
    if (step !== 1) {
      setContractSigningStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contractsReceived) {
      checkContractBlobs();
      if (showAssignQuotePopup) {
        toggleShowAssignQuotePopup(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractsReceived, visualizersLoadedLength]);

  const closeContracts = () => {
    history.push("/shoppingcart");
    //should we show order complete if contract wasn't signed?
    if (signedDocumentUrl && fabricatorSettings.checkout && (!fabricatorSettings.hasPaymentGateway || window.checkoutSuccess)) {
      showOrderCompletePopup(true)
    } else if (document.kvConfig.isBackend) {
      toggleShowAssignQuotePopup(true)
    }
  }

  const allValues = getAllContractsValues(contractsList, context);
  if (Config.isDevMode()) {
    console.log("allValues", allValues);
  }

  if (!contractsReceived || allValues.selectedContracts.some(contract => !contract.blobUrl)
    || (!showReceiptInContract && !allValues.activeContract)) {
    return <LoadingSpinner/>
  }

  const isFinished = step === 3;

  const changeContext = (newContextValues) => {
    setContext({...context, ...newContextValues});
  };

  return (
    <ContractsContext.Provider value={allValues} setContext={setContext}>
      <div
        className={"overlay overlay--contract" + (isSignaturePadVisible ? " overlay--contract-with-popup" : "")}>
        <button className="ui-close contract-close-button" style={{right: "40px"}} onClick={closeContracts}/>
        {isFinished
          ? <ContractsPopupSuccess closeSignPopup={closeContracts}/>
          : <ContractsPopupDocument changeContext={changeContext}/>}
      </div>
    </ContractsContext.Provider>
  )
};

const mapStateToProps = (store) => {
  const {contractsList, isVisible, step, contractsReceived, signedDocumentUrl} = store.contractSigningState;
  const {settings} = store.fabricatorState;
  const {showAssignQuotePopup} = store.assignQuoteState;

  return {
    contractsList,
    contractsPopupOpened: isVisible,
    step,
    contractsReceived,
    fabricatorSettings: settings,
    showAssignQuotePopup,
    visualizersLoadedLength: store.serverState.visualizersLoaded.length,
    signedDocumentUrl,
  };
};

const mapDispatchToProps = {
  setContractsList,
  showOrderCompletePopup,
  toggleShowAssignQuotePopup,
  setContractSigningStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsPopup)
